import * as React from 'react';

import { cn } from '@/lib/utils';

const Label = React.forwardRef<HTMLLabelElement, React.ComponentProps<'label'>>(
  ({ className, htmlFor, ...props }, ref) => {
    return React.createElement('label', {
      ref,
      htmlFor,
      'data-slot': 'label',
      className: cn(
        'gap-2 text-sm leading-none font-medium group-data-[disabled=true]:opacity-50 peer-disabled:opacity-50 flex items-center select-none group-data-[disabled=true]:pointer-events-none peer-disabled:cursor-not-allowed',
        className,
      ),
      ...props,
    });
  },
);

Label.displayName = 'Label';

export { Label };
